import React, { useState } from "react";
import step1 from '../../../assets/frothai/step-1.png';
import step2 from '../../../assets/frothai/step-2.png';
import step3 from '../../../assets/frothai/step-3.png';
import speed from '../../../assets/frothai/speed.png';
import output from '../../../assets/frothai/output.png';
import froth5 from '../../../assets/frothai/froth5.png';
import froth6 from '../../../assets/frothai/froth6.png';
import { useLocation } from "react-router-dom";
import "../../css/TestCase.css";
import { Helmet } from "react-helmet-async";

export default function TestCase() {
  const location = useLocation();
  const title = "AI Test Case Generation Tool | Smarter Test Design";
  const description = "Streamline your test creation process with AI-driven test case generation tool. Scalable software testing, Boost efficiency and deliver better software, faster.";
  const [activeTab, setActiveTab] = useState("requirements");

  return (
    <>
    <Helmet>
  <title>
    AI Test Case Generation Tool | Smarter Test Design
  </title>

  <meta
    name="description"
    content="Streamline your test creation process with AI-driven test case generation tool. Scalable software testing, Boost efficiency and deliver better software, faster."
  />

  <meta
    name="keywords"
    content="AI Test Case Generation Tool"
  />

  <link
    rel="canonical"
    href="https://frothtestops.com/froth-ai"
  />

  {/* Open Graph Tags */}
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:image" content="/images/og-image.jpg" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={`https://frothtestops.com${location.pathname}`} />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content="/images/og-image.jpg" />
</Helmet>
    <div className="testcase-wrapper">

      {/* Tabs */}
      <div className="tabs">

        <p
          className={`tab ${activeTab === "requirements" ? "active" : ""}`}
          onClick={() => setActiveTab("requirements")}
        >
          Test Scenarios and Test Cases with Requirements
        </p>

        <p
          className={`tab ${activeTab === "frothai" ? "active" : ""}`}
          onClick={() => setActiveTab("frothai")}
        >
          Generating Test Cases using FrothAI
        </p>

      </div>

      {/* TAB 1 */}
      {activeTab === "requirements" && (
        <div>

          <h3 className="title">
            Generating Test Scenarios and Test Cases with Requirements
          </h3>

          <p className="step">Step 1</p>
          <p className="desc">
            Seamlessly generate AI-powered test scenarios and test cases. Simply click on the FrothAI icon in the Actions section
            of any requirement within the Requirements Module to instantly create relevant test assets based on your selection.
          </p>

          <div className="img-wrap">
            <img src={step3} alt="step-1" />
          </div>

          <p className="step">Step 2</p>
          <p className="desc">
            When the FrothAI prompt opens, you can provide detailed requirement information and click the Generate button. FrothAI intelligently analyzes the requirement title to generate a precise set of test scenarios and test cases,ensuring contextual relevance.
          </p>

          <div className="img-wrap">
            <img src={step2} alt="step-2" />
          </div>

          <p className="step">Step 3</p>
          <p className="desc">
            Once the above step is complete, FrothAI presents a curated list of AI-suggested test scenarios and test cases. Users can review, refine, and expand entries for full visibility. With just a few clicks, selected test cases can be seamlessly imported into the Test Management Module by clicking the ‘Add’ button—streamlining test design for maximum efficiency.
          </p>

          <div className="img-wrap">
            <img src={step1} alt="step-3" />
          </div>

        </div>
      )}

      {/* TAB 2 */}
      {activeTab === "frothai" && (
        <div>

          <h3 className="title">
            Generating Test Cases with FrothAI
          </h3>

          <p className="step">Step 1</p>
          <p className="desc">
            Access the Create Test Case section within the Test Management Module. Enter the essential test case details, then click the FrothAI icon next to the input field to initiate AI-powered test case generation.
          </p>

          <div className="img-wrap">
            <img src={froth6} alt="froth-step-1" />
          </div>

          <p className="step">Step 2</p>
          <p className="desc">
            FrothAI intelligently analyzes the context, and auto-fills all key fields—Summary, Detail Steps, Expected Results, and other critical information—with a single click. Users can review, refine, and finalize before submitting, ensuring a seamless and structured test case creation experience.
          </p>

          <div className="img-wrap">
            <img src={froth5} alt="froth-step-2" />
          </div>

        </div>
      )}

    </div>
    </>
  );
}